import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/select/page',
    method: 'post',
    data
  })
}

export const exportExcel = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/delivery-order/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
